import { render } from "./custom-select.vue?vue&type=template&id=b19b27a6&ts=true"
import script from "./custom-select.vue?vue&type=script&lang=ts"
export * from "./custom-select.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__